import { render } from "./CarGoods.vue?vue&type=template&id=6281341e&scoped=true"
import script from "./CarGoods.vue?vue&type=script&lang=js"
export * from "./CarGoods.vue?vue&type=script&lang=js"

import "./CarGoods.vue?vue&type=style&index=0&id=6281341e&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6281341e"]])

export default __exports__